import { IExtParam } from './ext-param';

// tslint:disable-next-line:no-empty-interface
export interface ICategoryShort extends ISubCategoryShort {}

export interface ISubCategoryShort {
	parentCategoryId: number;
	defaultViewType: string;
	isPortal: boolean;
	name: string;
	id: number;
	subcategorySettings: ISubcategorySettings;
}

export interface ICategoryInfo {
	id: number;
	template: {
		extParamsColsBlocks: number;
		extParamsBlocks: IExtParamsBlocks[];
		extParams: IExtParamWithBlockInfo[];
	};
}
export interface IExtParamsBlocks {
	id: number;
	order: number;
	name: string;
	isExpandable: boolean;
	isExpanded: boolean;
	color: string;
}

export interface IExtParamsBlocksFromCategory {
	id: number;
	name: string;
	subcatId: number;
	canFold: boolean;
	defaultMinimized: boolean;
	defaultBlock: boolean;
	guid: string;
	order: number;
	color: string;
	localizedNameId: number;
	extParamIds: number[];
	extParams?: any;
}

export interface IExtParamWithBlockInfo extends IExtParam {
	blockId: number;
	order: number;
	colsWidth: number;
}
export interface ISubCategories {
	id: number;
	version: number;
	subcategory: ISubcategoryOptions;
	extParamsInSubcat: IExtParamsInSubcat[];
	stateRouteInSubcats: IStateRoutesSignature[];
	stepSubTasks: IStepSubTasks[];
	stateRoutesSignatures: IStateRoutesSignature[];
	customButtons: ICustomButtons[];
	extParamBlocks: IExtParamsBlocksFromCategory[];
}
export interface IExtParamsInSubcat {
	subcatId: number;
	extParamId: number;
	extParamName: string;
	isRequired: boolean;
	newTask: boolean;
	subcatOrder: number;
	isReadonly: boolean;
	accessControl: number;
	syncToParent: boolean;
	syncToChild: boolean;
	stateControl: boolean;
	newTaskMode: number;
	defaultValue: string;
	notifyOnChange: boolean;
	allowEditHistory: boolean;
	guid: string;
	changeWithComment: boolean;
	hidden: boolean;
	defaultValueSmartExpressionID: number;
	blockId: number;
	validatorId: number;
	colspan: number;
	maxLength: number;
	allowHistory: boolean;
	dontCopySourceTaskValue: boolean;
	smartAccessControl: boolean;
	encrypt: boolean;
}
export interface ICustomButtons {
	id: number;
	subcatId: number;
	name: string;
	memo: string;
	iconUrl: string;
	isVisible: boolean;
	actionsPackId: number;
	jsExpression: string;
	actionId: number;
	forOwner: boolean;
	forPerformer: boolean;
	forResponsiblePerformer: boolean;
	forAdmin: boolean;
	forAddRight: boolean;
	forViewer: boolean;
	visibilitySmartFilterId: number;
	urlSmartExpressionId: number;
	redirectActionTypeId: string;
	catSmartExpressionId: number;
	subcatSmartExpressionId: number;
	taskSmartExpressionId: number;
	taskSourceSmartExpressionId: number;
	sourceTaskSmartExpressionId: number;
	hideOnVisibilitySmartFilter: boolean;
	disabledReasonSmartExpressionId: number;
	disabledReason: string;
	guid: string;
}

export interface IStateRoutesSignature {
	id: number;
	stepId: number;
	signatureId: number;
	subcatId: number;
	isNecessarily: boolean;
	isByPerformer: boolean;
	signatureOrder: number;
	maxTimeToSign: number;
	isForMainAcceptor: boolean;
	spName: string;
	reason: string;
	returnIfNotSignedStateId: number;
	canChangeSigRequestReason: boolean;
	sigRequestReasonRequired: boolean;
	guid: string;
	actionIfNotSigned: number;
	excludeAlreadySigned: boolean;
	smartFilterId: number;
	requestReasonOnAccept: boolean;
	isByResponsiblePerformer: boolean;
	canBeEscalated: boolean;
	timeToSignSmartId: number;
	escalateOnOverDue: boolean;
	isOwnerSignature: boolean;
	enabled: boolean;
	reasonSmartId: number;
	splitForEachAcceptor: boolean;
	acceptorsEvalutionBaseUser: number;
	baseUserSmartId: number;
	canBeDelegated: boolean;
	isMainRouteStep: boolean;
	stateID: number;
	stateNextID: number;
	stepDescr: string;
	isEds: boolean;
}

export interface IStateRouteInSubcat {
	stateID: number;
	stateNextID: number;
	actionID: number;
	ownerOnly: boolean;
	userOnly: boolean;
	subcatID: number;
	stepDescr: string;
	hiddenStep: boolean;
	stepToolTip: string;
	autoPerformerSignatureID: number;
	autoperformerAssingAction: number;
	termMinutes: number;
	transparentApproval: boolean;
	forceComment: boolean;
	resetDueTime: boolean;
	stepOwnerToolTip: string;
	stepUserToolTip: string;
	isButtonPresserAutoPerformer: boolean;
	autoAssignCustomer: boolean;
	cycleApproval: boolean;
	disableMail: boolean;
	autoPerformStepOnSubtasksClose: boolean;
	onOverduePerformStepID: number;
	confirmText: string;
	termDateSourceExtParamID: number;
	requestDirectorSignatureOnReject: boolean;
	forAdmin: boolean;
	forViewver: boolean;
	taskStartTimeAction: number;
	askPermissionToPerformTSTAction: boolean;
	autoPerformerSourceExtParamID: number;
	isAutoPerfomedOnPostTask: boolean;
	guid: string;
	storedProcedures: string;
	changeTaskText: boolean;
	changeTaskTextTemplate: string;
	forPerfRight: boolean;
	forAddRight: boolean;
	forResponsiblePerformer: boolean;
	notifyUsersInSubcat: boolean;
	notifyUsersInSubcatText: string;
	notifyUsersInSubcatGroupID: number;
	actionsWithExtParams: number;
	visibilitySmartFilterID: number;
	disallowRevisionsOnSign: boolean;
	doSetComplainted: boolean;
	removeCommentsOnSignWhenEP: number;
	redirectUrlAfterStepSmartExpressionID: number;
	isMainRouteStep: boolean;
	isMainRouteAvailable: boolean;
	requireChangeDateBefore: boolean;
	localizedStepDescrId: number;
}

export interface IStepSubTasks {
	stepId: number;
	subcatId: number;
	taskDescr: string;
	includeParentDescr: boolean;
	isLinked: boolean;
	copySubscribersFromParent: boolean;
	fromWhom: number;
	assignToParentTaskOwner: boolean;
	customerRoleToAssignID: number;
	copyPerformers: boolean;
	copyOnlyResponsiblePerformer: boolean;
	separateTaskForEachPerformer: boolean;
	performersFromGroupID: number;
	orderedTimeMode: number;
	orderedTimeExtParam: number;
	copyAttachmentsFromParent: boolean;
	guid: string;
	orderedTimeOffset: number;
	orderedTimeOffsetUnit: number;
	smartFilterID: number;
}

export interface ISubcategoryOptions {
	id: number;
	version: number;
	subcatTypeID: number;
	description: string;
	details: string;
	categoryId: number;
	guid: string;
	entity: string;
	sendButton: string;
	srokName: string;
	requireSubtaskFinish: boolean;
	defaultText: string;
	forMailAdministrators: string;
	responsibleGroupID: number;
	newTaskMessage: string;
	customerID: number;
	textToAppendToSubjects: string;
	useEPTemplate: boolean;
	ePTemplate: string;
	enableSms: boolean;
	taskStartTimeName: string;
	parentTaskDescriptionReference: string;
	forbidUploadFilesIntoClosedTasks: boolean;
	notifyResponsibleStateChange: boolean;
	isPortal: boolean;
	isNotice: boolean;
	forbidMovingTasks: boolean;
	memo: boolean;
	fullPath: string;
	docxTemplateProtectionLevel: number;
	fullPathIds: string;
	isForProjects: boolean;
	isForProjectTasks: boolean;
	projectTasksSubcatId?: number;
	giveRightsOnlyToADGroups: boolean;
	autoDeletePrevVersionsOfFiles: boolean;
	allowSignatureRevoke: boolean;
	allowSignatureRevokeByAcceptors: boolean;
	projectPlannedSumEpId?: number;
	projectFactSumEpId?: number;
	projectCurrencyName: string;
	projectShortDateView: boolean;
	additionalSyndicateLink: string;
	disableTasksMove: boolean;
	addSubscriberText: string;
	addSubscribersText: string;
	technicalWorksText?: string;
	isTechnicalWorksNow?: boolean;
	isSystemSubcat: boolean;
	isResourceReservation: boolean;
	isTasksLayoutSubcat: boolean;
	isForSurveys: boolean;
	taskLikesEnabled: boolean;
	enableTaskViewsCounter: boolean;
	enableTaskUserCommentsCounter: boolean;
	allowSignatureRevokeByOwner: boolean;
	allowSignatureRevokeByRequester: boolean;
	mobileTemplateID: number;
	showExtParamsAfterBlocks: boolean;
	severalDecompositions: boolean;
	isForProjectForceTasks: boolean;
	mtfDefaultExtParamTableColumns?: number;
	ntfDefaultExtParamTableColumns?: number;
	extParamsBlocksColor: string;
	mobileTaskTemplateId?: number;
	msOfficeInteractionSettingId?: number;
	isCalendar: boolean;
	tasksIsNotOverdue: boolean;
	mobileCellTemplateId?: number;
	isSaveUsersSettingsForGrid: boolean;
	isPinnedToChats: boolean;
	disableTasksCopyFromSubcategory: boolean;
	disableTasksCopyToSubcategory: boolean;
	toolbarConfig: any;
	localizedDescriptionId?: number;
	localizedEntityId?: number;
	dueOptions?: any;
	viewAndPermissions?: IViewPermissions;
	srokMode?: SubcategoryDueMode;
	taskParticipantsOptions?: ITaskParticipantsOptions;
}

export interface IViewPermissions {
	displayTaskStartDate?: boolean;
	showTasksInTerminalStatusInCalendar?: boolean;
}

export interface ITaskParticipantsOptions {
	performerMode: 'Disallow' | 'Allow' | 'Deny' | 'Must';
}

export interface ISubcategorySettings {
	availableRepresentations?: SubcategoryRepresentation[];
}

export enum SubcategoryRepresentation {
	grid = 'Grid',
	feeds = 'Feeds',
	calendar = 'Calendar',
	gantt = 'Gantt',
	kanban = 'Kanban',
}

export enum SubcategoryDueMode {
	required = 'Required',
	enabled = 'Enabled',
	disabled = 'Disabled',
}
